import { render, staticRenderFns } from "./CommentsStrategyProject.vue?vue&type=template&id=5fcb44bc&scoped=true"
import script from "./CommentsStrategyProject.vue?vue&type=script&lang=js"
export * from "./CommentsStrategyProject.vue?vue&type=script&lang=js"
import style0 from "./CommentsStrategyProject.vue?vue&type=style&index=0&id=5fcb44bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb44bc",
  null
  
)

export default component.exports